import { LitElement, html, css } from 'lit';
import { restMethods } from '../mixins/rest_methods'
import { createSuccessBar } from '../packs/notification_bar'
import './outline_button';

class requestAvailabilityButton extends LitElement {
  static properties = {
    id: { type: Number, reflect: true },
    requestedAvailability: { type: Boolean, reflect: true },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.requestAvailability = false
    window.setInterval(() => {
      this.requestedAvailability = localStorage.getItem(`request_facility_availability_${this.id}`)
    }, 1000)
  }
  static styles = css`
    `
  async clickRequestAvailabilityButton() {
    const res = await restMethods.methods.postMethod(`/facilities/${this.id}/request_availability`)
    localStorage.setItem(`request_facility_availability_${this.id}`, 'true')
    if(res.status === 200){
      createSuccessBar('この施設の“空き状況の取得”をリクエストしました。気長にお待ちいただけますと幸いです。');
      this.requestedAvailability = true

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'request_scraping',
        facility_id: this.id
      });

      return true
    }
  }
  updated(changedProperties) {
    if(changedProperties.has('id')){
      this.requestedAvailability = localStorage.getItem(`request_facility_availability_${this.id}`)
    }
  }
  render() {
    return html`
      <div
        @click="${this.clickRequestAvailabilityButton}"
      >
        <outline-button
          ?disabled="${this.requestedAvailability}"
        >
          空き状況の取得をリクエストする
        </outline-button>
      </div>
    `;
  }
}

if (!customElements.get('request-availability-button'))
  customElements.define('request-availability-button', requestAvailabilityButton);